/* istanbul ignore file */

/* tslint:disable */

/* eslint-disable */
export var DuplicationEntityName;

(function (DuplicationEntityName) {
  DuplicationEntityName["QUOTE"] = "quote";
  DuplicationEntityName["VALIDATION"] = "validation";
})(DuplicationEntityName || (DuplicationEntityName = {}));